/**
 * BClickableArtistName - A chip that opens BArtistLightbox when clicked
 *
 * B UI version of ClickableArtistName - uses BArtistLightbox for consistent styling.
 */

import { useState, useCallback, lazy, Suspense } from 'react';
import { createPortal } from 'react-dom';
import './BArtistLightbox.css';

// Lazy load BArtistLightbox to avoid circular import
const BArtistLightbox = lazy(() => import('./BArtistLightbox'));

interface BClickableArtistNameProps {
  name: string;
  className?: string;
  children?: React.ReactNode;
}

export function BClickableArtistName({ name, className = '', children }: BClickableArtistNameProps) {
  const [showLightbox, setShowLightbox] = useState(false);

  const handleClick = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowLightbox(true);
  }, []);

  if (!name) {
    return null;
  }

  return (
    <>
      <button
        className={className || 'b-artist-card__member-chip'}
        onClick={handleClick}
        title={`View ${name}`}
      >
        {children || name}
      </button>
      {showLightbox && createPortal(
        <Suspense fallback={
          <div className="b-artist-lightbox-overlay">
            <div className="b-lightbox-loading">
              <div className="b-loading-spinner" />
            </div>
          </div>
        }>
          <BArtistLightbox
            artistName={name}
            onClose={() => setShowLightbox(false)}
          />
        </Suspense>,
        document.body
      )}
    </>
  );
}
